export function withButtonDisabled<T>(request: Promise<T>, button: HTMLButtonElement) {
    button.disabled = true;
    return request.finally(() => button.disabled = false);
}